export default(() => {
    const toggles = Array.from(document.querySelectorAll('.member-carousel__header-link'));

    toggles.forEach((toggle) => {

        toggle.addEventListener('click', (event) => {
            event.preventDefault();

            toggles.forEach((item) => {
                const image = item.querySelector('img');
                item.classList.remove('is-active');
                image.src = image.dataset.logoGreyscale;
            });

            const image = toggle.querySelector('img');
            toggle.classList.add('is-active');
            image.src = image.dataset.logoColoured;

            const index = [...toggle.parentNode.children].indexOf(toggle);
            const slides = Array.from(document.querySelectorAll('.member-carousel__slide'));

            slides.forEach((slide) => {
                slide.classList.remove('is-active');
            });

            slides[index].classList.add('is-active');
        });

    });
})();
